import React, {Suspense, useEffect, useState} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import {Spinner} from 'react-bootstrap';
import {Routes} from './routes';
import {useProfile} from '../utils/useProfile';
import {SetPasswordGate} from '../pages/auth/SetPasswordGate';
import ApiService from '../redux/services/api-service';

const AppRoutes = (): React.ReactElement => {
  const {loadProfile, profile} = useProfile();
  const [isReady, setIsReady] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathName = location.pathname;
    const token: any = localStorage.getItem('token');
    const refreshToken: any = localStorage.getItem('refresh');

    const tokenParts = token ? JSON.parse(window.atob(token.split('.')[1])) : '';
    const refreshParts = refreshToken ? JSON.parse(window.atob(refreshToken.split('.')[1])) : '';

    // exp date in token is expressed in seconds, while now() returns milliseconds:
    const now = Math.ceil(Date.now() / 1000);

    if (tokenParts.exp > now) {
      console.log('not yet expired');
    }
    if (pathName === '/change-password') return;
    if (pathName.startsWith('/public')) return;
    if (pathName === '/sign-up' || pathName === '/sign-up/') return;
    if (token === 'undefined' || token === null) navigate('/sign-in');
    if (pathName === '/') navigate('/sign-in');
    if (
      pathName === '/sign-in' &&
      token !== 'undefined' &&
      token !== null &&
      tokenParts.exp > now &&
      refreshToken &&
      refreshParts.exp > now
    )
      navigate('/home');
    else if (
      pathName === '/sign-up' &&
      token !== 'undefined' &&
      token !== null &&
      tokenParts.exp > now &&
      refreshToken &&
      refreshParts.exp > now
    )
      navigate('/home');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (ApiService.defaults.headers.Authorization) {
      loadProfile();
    }
    setIsReady(true);
  }, [loadProfile, setIsReady]);

  if (!isReady) {
    return <Spinner animation="border" />;
  }
  // A user on an admin-issued temporary password gets nothing but the password form. Rendered
  // in place of the routes rather than as a redirect, so there is no route to navigate around.
  // Not while impersonating: the flag belongs to the user being viewed, and only they can
  // clear it (setting a password is refused for impersonated requests). Showing the gate here
  // would just strand the staff user on a form they cannot submit.
  if (profile?.must_change_password && !profile?.impersonation?.active) {
    return <SetPasswordGate />;
  }
  return (
    <Suspense fallback={<Spinner animation="border" />}>
      <Routes />
    </Suspense>
  );
};

export default AppRoutes;
